export default class CountdownBanner {
  constructor() {
    this.container = null;
    this.hoursElement = null;
    this.minutesElement = null;
    this.secondsElement = null;
    this.targetDate = null;
    this.intervalId = null;
  }

  init() {
    this.container = document.querySelector('[data-countdown-container]');
    
    if (!this.container) {
      return;
    }

    this.hoursElement = this.container.querySelector('[data-hours]');
    this.minutesElement = this.container.querySelector('[data-minutes]');
    this.secondsElement = this.container.querySelector('[data-seconds]');

    if (!this.hoursElement || !this.minutesElement || !this.secondsElement) {
      console.warn('CountdownBanner: Elementos do contador não encontrados');
      return;
    }

    this.setTargetDate();
    this.updateCountdown();
    this.startCountdown();
  }

  setTargetDate() {
    const now = new Date();
    const daysToAdd = window.countdownBannerConfig?.daysToAdd || 3;
    
    this.targetDate = new Date(now);
    this.targetDate.setDate(this.targetDate.getDate() + daysToAdd);
    this.targetDate.setHours(0, 0, 0, 0);
  }

  getTimeLeft() {
    const now = new Date().getTime();
    const targetTime = this.targetDate.getTime();
    const diff = targetTime - now;

    if (diff <= 0) {
      return { hours: 0, minutes: 0, seconds: 0, finished: true };
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return { hours, minutes, seconds, finished: false };
  }

  padNumber(num) {
    return String(num).padStart(2, '0');
  }

  updateCountdown() {
    const timeLeft = this.getTimeLeft();

    this.hoursElement.textContent = this.padNumber(timeLeft.hours);
    this.minutesElement.textContent = this.padNumber(timeLeft.minutes);
    this.secondsElement.textContent = this.padNumber(timeLeft.seconds);

    if (timeLeft.finished) {
      this.stopCountdown();
      this.onCountdownFinished();
    }
  }

  startCountdown() {
    this.intervalId = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  stopCountdown() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  onCountdownFinished() {
    const section = this.container?.closest('section');
    if (section) {
      section.classList.add('countdown-finished');
    }
    console.log('Countdown finalizado');
  }

  destroy() {
    this.stopCountdown();
  }
}
